import {playerDrag} from './drag';

export default {
    playerDrag
};
